import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateUnitApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateUnit = createAsyncThunk('updateUnit', async (payload) => {
  return await updateUnitApi(payload);
});

const updateUnitSlice = createSlice({
  name: 'updateUnit', // Unique Name
  initialState,
  reducers: {
    updateUnitReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUnit.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateUnit.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateUnit.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateUnitReset } = updateUnitSlice.actions;

export default updateUnitSlice.reducer;
